var C={50:"#ecfbf9",100:"#ecfbf9",200:"#D8F8F2",300:"#9EEDE0",400:"#59E0C9",500:"#3CDBC0",600:"#3CDBC0",700:"#3CDBC0",800:"#3CDBC0"};export{C as default};
